import { Form, useOutletContext } from 'react-router-dom';
import Wrapper from '../assets/wrappers/DashboardFormPage';
import { FormRow, SubmitBtn, ImageComponent } from '../components';
import { customFetch } from '../utils/custom-fetch.js';
import { toast } from 'react-toastify';

export const action = async ({ request }) => {
  const formData = await request.formData();
  const file = formData.get('avatar');
  if (file && file.size > 500000) {
    toast.error('גודל הקובץ גדול מדי');
    return null;
  }

  try {
    await customFetch.patch('/users/update-user', formData);
    toast.success('הפרטים עודכנו בהצלחה');
  } catch (error) {
    toast.error(error?.response?.data?.msg);
  }

  return null;
};

const Profile = () => {
  const { user } = useOutletContext();
  const { name, lastName, city, email, avatar } = user;
  return (
    <Wrapper>
      <Form method='post' className='form' encType='multipart/form-data'>
        <h4 className='form-title'>פרופיל</h4>
        {/* <img src={avatar} alt='avatar' className='img' /> */}

        <div className='form-center'>
          <div className='form-row'>
            <label htmlFor='avatar' className='form-label'>
              בחר קובץ (גודל מקסימלי 10 MB)
            </label>
            <input
              type='file'
              id='avatar'
              name='avatar'
              className='form-input'
              accept='image/*'
            />
          </div>

          <FormRow
            type='text'
            name='name'
            labelText='שם פרטי'
            defaultValue={name}
          />

          <FormRow
            type='text'
            name='lastName'
            labelText='שם משפחה'
            required
            defaultValue={lastName}
          />

          <FormRow
            type='text'
            name='city'
            labelText='עיר מגורים'
            required
            defaultValue={city}
          />
          <FormRow
            type='email'
            name='email'
            labelText='כתובת דואר אלקטרוני'
            defaultValue={email}
            required
          />
          <SubmitBtn formBtn buttonText='שמירה' />
        </div>
      </Form>
    </Wrapper>
  );
};
export default Profile;
